module.exports = __webpack_public_path__ + "img/icon-earth-globe.57184aa8.svg";